import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { lastValueFrom } from 'rxjs';
import { AttachmentModel } from '@fc-vehicles/service/attachment-model';

@Injectable({
  providedIn: 'root',
})
export class ChatAttachmentsApiService {
  private http = inject(HttpClient);

  addFile(file: File, channelId: string): Promise<AttachmentModel> {
    const formData = new FormData();

    formData.append('original', file);

    if (file.name) {
      formData.append('name', file.name);
    }

    return lastValueFrom(
      this.http.post<AttachmentModel>(
        environment.apiUrl +
          'api/files/chat_channels/' +
          `${channelId}/attachments/`,
        formData,
      ),
    );
  }

  getAttachment(id: number): Promise<AttachmentModel> {
    return lastValueFrom(
      this.http.get<AttachmentModel>(
        environment.apiUrl + 'api/files/chat/' + `attachments/${id}/`,
      ),
    );
  }

  deleteFile(id: number): Promise<void> {
    return lastValueFrom(
      this.http.delete<void>(
        environment.apiUrl + 'api/files/chat/' + `attachments/${id}/`,
      ),
    );
  }
}
